const updateSelectedVariant = (form, product) => {
  if (!form || !product) return null;
  const idField = form.querySelector('input[name="id"]');
  const submit = form.querySelector('button[type="submit"]');
  if (!idField || !submit) return;

  const selectedValues = [];
  form.querySelectorAll('[product-option] input[type="radio"]:checked').forEach(option => {
    selectedValues.push({
      value: option.value,
      index: option.name
    });
  });

  const variant = product.variants.find(variant => {
    return selectedValues.every(value => {
      return variant[value.index] == value.value;
    });
  });

  if (variant) {
    idField.value = variant.id;
    submit.disabled = variant.available ? false : true;
  } else {
    idField.value = '';
    submit.disabled = true;
  }
};

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const quickBuy = tile.querySelector('.product-tile__quick-buy');
  if (quickBuy) {
    const productForm = quickBuy.querySelector('form.product-tile-quick-buy__options-wrapper');
    if (!productForm) return;
    const submit = productForm.querySelector('button[type="submit"]');
    const productJsonScript = productForm.querySelector('[product-json]');
    const idField = productForm.querySelector('input[name="id"]');
    if (!idField || !productJsonScript || !productJsonScript.innerHTML.trim() || !submit) return;
    const product = JSON.parse(productJsonScript.innerHTML.trim());
    updateSelectedVariant(productForm, product);

    tile.addEventListener('mouseleave', () => {
      quickBuy.classList.remove('open');
    });

    const opener = quickBuy.querySelector('.product-tile-quick-buy__opener');
    if (opener) {
      opener.addEventListener('click', () => {
        const notHiddenOptions = productForm.querySelectorAll('.product-tile-quick-buy__option:not(.product-tile-quick-buy__option--hidden)');
        if (notHiddenOptions.length > 0) {
          quickBuy.classList.add('open');
        } else {
          updateSelectedVariant(productForm, product);
          submit.click();
        }
      });
    }

    productForm.querySelectorAll('.product-tile-quick-buy__option input[type="radio"]').forEach(option => {
      option.addEventListener('change', () => {
        updateSelectedVariant(productForm, product);
        submit.click();
      });
    });

    productForm.addEventListener('submit', e => {
      e.preventDefault();
      if (typeof (ShopifyAPI) !== 'undefined' && typeof (ShopifyAPI.addItemFromForm) !== 'undefined') {
        ShopifyAPI.addItemFromForm(
          productForm,
          () => {
            if (typeof (ShopifyAPI.getCart) !== 'undefined') {
              ShopifyAPI.getCart(() => {
                if (typeof (ajaxCart) !== 'undefined' && typeof (ajaxCart.load) !== 'undefined') {
                  ajaxCart.load();
                }
              });
            }
          }
        );
      } else {
        productForm.submit();
      }
    });
  }
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}
